import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-fixed bottom-0 end-0 p-3 z-index-toast" }
const _hoisted_2 = {
  id: "updateToast",
  class: "toast hide",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true"
}
const _hoisted_3 = { class: "toast-header" }
const _hoisted_4 = { class: "me-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1)
const _hoisted_6 = { class: "toast-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.$t('text.update_available')), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('text.reload_site')), 1),
          _createVNode(_component_Button, {
            "btn-style": "btn-sm btn-secondary border-0",
            "btn-type": "button",
            onClick: _ctx.reloadSite
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('text.reload')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}